import { openCartAtom } from "@models/state/cart/index";
import { useAtom } from "jotai";

export function useDrawer() {
  const [isOpen, setIsOpen] = useAtom(openCartAtom);

  function openDrawer() {
    setIsOpen(true);
  }

  function closeDrawer() {
    setIsOpen(false);
  }

  return {
    models: {
      isOpen,
    },
    operations: {
      openDrawer,
      closeDrawer,
    },
  };
}
